class PositionClosed {
	constructor() {
		this.id = '';
		this.symbol = '';
		this.side = 1;
		this.volume = 0;
		this.priceEnter = 0;
		this.curPrice = 0;
		this.resultDepo = 0;
		this.resultPoint = 0;
		this.timeEnter = null;
		this.timeExit = null;
		this.sl = 0;
		this.tp = 0;
	}
	static parsePositionsArray(arrayOfArrays) {
		// [{id},\"{symbol}\",{side},{volume},{priceEnter},{curPrice},{resultDepo},{resultPoint},\"{timeEnter:yyyy.MM.ddTHH:mm:ss}\",\"{timeExit:yyyy.MM.ddTHH:mm:ss}\",{sl},{tp}]
		let positions = [];
		for (let i = 0; i < arrayOfArrays.length; i++) {
		  	let ar = arrayOfArrays[i];
		  	let pos = {
				id: ar[0],
				symbol: ar[1],
				side: ar[2],
				volume: ar[3],
				priceEnter: ar[4],
				curPrice: ar[5],
				resultDepo: ar[6],
				resultPoint: ar[7],
				timeEnter: ar[8],
				timeExit: ar[9],
				sl: ar[10],
				tp: ar[11]
		  	};
		  	positions.push(pos);
		}
		return positions;
	}
}

export { PositionClosed };